// AI Generated Component
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LinkPagesRepoService } from '@client/app/services/api/link-pages-repo/link-pages-repo.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { CheckForDuplicatesService } from '@client/app/core/services/check-for-duplicates/check-for-duplicates.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-dialog-links-pages',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header [header]="'Pages related to policy link' | translate" [subHeader]="subHeader">
                <page-header-content>
                    <div class="mon-dialog-delay-fadein d-flex">
                        <div class="mt-1">
                            <csv-export-button [exports]="exports"></csv-export-button>
                            <a *ngIf="showFilters"
                               (click)="isFiltersOpen = !isFiltersOpen"
                               class="text-link inline-block mt-1 cursor-pointer">
                                <span class="fas fa-filter fa-lg" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="mt-1 pl-4 flex-fill-column-width">
                            <table-search [minSearchLength]="3"
                                          class="block mr-2"
                                          theme="grey-theme"
                                          [placeholderTxt]="'Search...' | translate"
                                          [(model)]="search"
                                          (getPage)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                    <div class="row">
                        <div class="col-48" [ngClass]="{'merge-t-16': isFiltersOpen}">
                            <table-filters [(open)]="isFiltersOpen"
                                           [(ngModel)]="filters"
                                           [filters]="availableFilters"
                                           *ngIf="showFilters"
                                           (onChanges)="onFiltersChanged($event)">
                            </table-filters>
                        </div>
                    </div>
                    <table-container [collection]="pages"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     class="pages-table-wrapper"
                                     [progress]="progress"
                    >
                        <table class="table table-hover table-fixed table-with-labels">
                            <thead>
                            <tr>
                                <th translate>
                                    Title
                                </th>
                                <th class="col-sm-4 col-md-4 col-lg-4" translate>Priority</th>
                                <th class="col-sm-3 col-md-4 col-lg-4" translate *ngIf="viewsColumIsAvailable">Views</th>
                                <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td>
                                    <div class="text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable"
                                                [target]="'page-details-section-policies'"
                                                [subTarget]="policy"
                                                [title]="page.title"
                                                (onClose)="onPageDetailsClose()"
                                                [url]="page.url"
                                                [page]="page"
                                                [active]="false">
                                        </url-title-page-details>
                                    </div>
                                    <label-table *ngIf="showLabels"
                                                 [assignedLabels]="page.labels"
                                                 (getLabels)="getLabels()"
                                                 [existingLabels]="labels"
                                                 (onUpdateLabel)="updateLabels(page)">
                                    </label-table>
                                </td>
                                <td class="text-v-middle">
                                    <mon-priority class="vcenter" [priority]="page.priority_score_as_text"></mon-priority>
                                </td>
                                <td class="text-v-middle" *ngIf="viewsColumIsAvailable">
                                    <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pagesData.pageHits"></visits>
                                </td>
                                <td class="text-right text-v-middle" [attr.aria-label]="'Page details' | translate">
                                    <div class="pr-2">
                                        <table-page-details
                                                [ngbTooltip]="'Open page details' | translate"
                                                [triggers]="'focus hover'"
                                                [target]="'page-details-section-policies'"
                                                [subTarget]="policy"
                                                class="list-inline inline-block"
                                                [page]="page">
                                        </table-page-details>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PagesPolicyDialogLinksPagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    @Input() link: any;
    @Input() policy: any;

    pages: any[] = [];
    subHeader: string = '';
    exports: any[] = [];
    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    progress: any;
    eventId: any;

    constructor (
        private linkPagesRepoService: LinkPagesRepoService,
        private baseEntityService: BaseEntityService,
        private translateService: TranslateService,
        private checkForDuplicatesService: CheckForDuplicatesService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.eventId = this.monEventsService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.search = '';
        this.isFiltersOpen = false;
        this.subHeader = '<a href="' + this.link.url + '" target="_blank" aria-describedby="linkOpensInNewTab">' + this.link.url + '</a>';
        this.exports = [
            {
                name: this.translateService.getString('Content with Policy Matches'),
                data: {
                    category: 'pages_with_specific_link',
                    category_ref: this.link.id,
                },
            },
        ];
        this.getPage();
        this.getLabels();
    }

    ngOnDestroy (): void {
        this.monEventsService.remove(this.eventId);
    }

    override getPage (): void {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            link_id: this.link.id,
            search: this.search || null,
        };

        const updatedParams = this.updateParamsWithFilters(params);

        this.progress = this.linkPagesRepoService.get(updatedParams).then((data: any) => {
            this.checkForDuplicatesService.checkForDuplicatePages(data);
            this.pages = data;
        }, () => {});
    }

    onFiltersChanged (changes: any): void {
        this.updateFilters(changes);
        this.getPage();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    get pagesData (): any {
        return this.pages as any;
    }
}
